<template>
  <div class="unsupported-bank-goodbye">
    <riseup-header/>
    <div class="image-wrapper">
      <img :src="require('@/assets/onboarding/big-icon-rising.svg')" class="sun-image">
    </div>
    <div class="title">הצוות שלנו על זה! נעדכן אותך כשנתמוך ב{{ sourceDisplayName }}</div>
    <div class="description">
בגלל שכרגע אנחנו לא תומכים בחשבון הבנק העיקרי שלך לא נוכל לבנות לך תזרים.<br>
      <span class="bold">נעדכן אותך ב-WhatsApp</span> ברגע שנתמוך בו. מקווים שבקרוב נוכל לעזור לך לנצח את החודש!
    </div>
  </div>
</template>

<script>

import Segment from '../../Segment';
import RiseupHeader from '../app-header/RiseupHeader.vue';

export default {
  name: 'UnsupportedBankGoodbye',
  components: {
    RiseupHeader,
  },
  props: {
    sourceName: {
      type: String,
      required: true,
    },
    sourceDisplayName: {
      type: String,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('UnsupportedBanksMessagePageEntered', { sourceName: this.sourceName });
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';

.unsupported-bank-goodbye {
  text-align: center;

  .image-wrapper {
    width: 100%;
    margin: 60px 0 40px;

    .sun-image {
      width: 120px;
    }
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    margin: 0 50px 20px 50px;
  }

  .description {
    font-size: 16px;
    line-height: 1.5;
    margin: 0 32px 0 32px;

    .bold {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/UnsupportedBankGoodbye.vue